<script setup lang="ts">
import type { HTMLAttributes } from 'vue'

defineProps<{
  class?: HTMLAttributes['class']
  name?: string
}>()
</script>

<template>
  <div
    :class="
      cn([
        'border border-r-0 rounded-l-xl px-3 flex items-center border-grey group-focus-within/input-icon:border-primary bg-white/50 text-secondary group-focus-within/input-icon:text-primary transition',
        $props.class,
      ])
    "
  >
    <Icon :name />
  </div>
</template>
